import ThemedComponent from '../../hoc/ThemedComponent';
import { default as PaymentsOrdersFormViewDefault } from './PaymentsOrdersForm/View';
import { default as PaymentsOrdersFormView3 } from '../../themes/3/components/Finances/PaymentsOrdersForm';
import { default as PaymentsOrdersFormView4 } from '../../themes/4/components/Finances/PaymentsOrdersForm';

import { default as PaymentOrdersViewDefault } from './PaymentOrders/View';
import { default as PaymentOrdersView3 } from '../../themes/3/components/Finances/PaymentOrders';
import { default as PaymentOrdersView4 } from '../../themes/4/components/Finances/PaymentOrders';

const ThemedPaymentsOrdersForm = {
  default: PaymentsOrdersFormViewDefault,
  // 3: PaymentsOrdersFormView3,
  // 4: PaymentsOrdersFormView4,
};

const ThemedPaymentOrders = {
  default: PaymentOrdersViewDefault,
  // 3: PaymentOrdersView3,
  // 4: PaymentOrdersView4,
};

export const PaymentsOrdersFormView = ThemedComponent(ThemedPaymentsOrdersForm);

export const PaymentOrdersView = ThemedComponent(ThemedPaymentOrders);